import { OfflineState } from '@/state/offline-management'
import OnlineIndicator from './online'
import OfflineIndicator from './offline'
import SynchronizingIndicator from './synchronizing'

import './styles.scss'

export default function OfflineManagementCurrentStatus() {
  if (OfflineState.isSynchronizing.value) {
    return <SynchronizingIndicator />
  }

  if (OfflineState.isOnline.value) {
    return <OnlineIndicator />
  }

  if (!OfflineState.isOnline.value) {
    return <OfflineIndicator />
  }

  return null
}
